import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

export interface Crumb { label: string; to?: string; mono?: boolean }

const Ctx = createContext<{ crumbs: Crumb[]; set: (c: Crumb[]) => void }>({ crumbs: [], set: () => {} });

export function CrumbsProvider({ children }: { children: ReactNode }) {
  const [crumbs, set] = useState<Crumb[]>([]);
  return <Ctx.Provider value={{ crumbs, set }}>{children}</Ctx.Provider>;
}

/** Screens declare their breadcrumb; the top bar renders it. */
export function useCrumbs(crumbs: Crumb[]) {
  const { set } = useContext(Ctx);
  const key = JSON.stringify(crumbs);
  useEffect(() => { set(crumbs); }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}

export const useCrumbState = () => useContext(Ctx).crumbs;
